<template>
    <div id="app">
        <div class="boxBoss">
            <Main :language="language" />
            <GameFeatures :language="language" />
            <!-- <Swiper /> -->
            <div class="bottomWrap">
                <!-- <div class="storeWrap">
                    <a href="https://apps.apple.com/app/punball/id15857813666">
                        <img src="@/assets/images/store_a.png" alt="" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.habby.punball">
                        <img src="@/assets/images/store_g.png" alt="" />
                    </a>
                    <a :href="srcUrl">
                        <img :src="require('@/assets/images/' + abc + '/store_f.png')" />
                    </a>
                </div> -->
                <div class="tipsWrap" v-show="isBottom">
                    <div class="imgWrap">
                        <img src="@/assets/images/gameLeft.jpg" alt="" />
                    </div>
                    <div class="imgWrap" style="margin-left: 1rem" v-show="language === 'zh-TW'">
                        <img src="@/assets/images/game.png" alt="" />
                    </div>
                    <div class="tips" v-html="textBottom"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Main from './components/Main'
import GameFeatures from './components/GameFeatures.vue'
import { lang } from '@/tool/lang'
import { myHTTP } from '@/utils/net'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    components: {
        Main,
        GameFeatures
    },
    data() {
        return {
            isBottom: false,
            scrollTop: 0,
            language: '',
            srcList: {
                en: 'https://www.facebook.com/PunBall-101202141749652',
                ja: 'https://www.facebook.com/%E3%83%9D%E3%83%B3%E3%83%9C%E3%83%BC%E3%83%AB-106943275069145/',
                ko: 'https://www.facebook.com/%ED%95%80%EB%B3%BC%EB%8F%84%EC%82%AC-261783855675444',
                zh: 'https://www.facebook.com/%E7%A0%B0%E7%A0%B0%E6%B3%95%E5%B8%AB-107459635017806'
            },
            srcUrl: '',
            abc: '',
            textBottom: '',
            lang2: ''
        }
    },
    created() {
        if (
            parsed.language &&
            (parsed.language === 'en' ||
                parsed.language === 'zh-TW' ||
                parsed.language === 'zh-CN' ||
                parsed.language === 'ja' ||
                parsed.language === 'ko')
        ) {
            this.language = parsed.language
            this.abc = this.language
            this.lang2 = this.language.substr(0, 2)
            this.srcUrl = this.srcList[this.language.substr(0, 2)]
        } else {
            var type = navigator.appName
            if (type == 'Netscape') {
                var lang = navigator.language //获取浏览器配置语言，支持非IE浏览器
            } else {
                var lang = navigator.userLanguage //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
            }
            var lang2 = lang.substr(0, 2) //获取浏览器配置语言前两位
            this.lang2 = lang2
            if (lang2 === 'zh') {
                let zh = lang.substr(0, 5)
                this.language = zh
            } else if (lang2 == 'ko') {
                this.language = 'ko'
            } else if (lang2 == 'ja') {
                this.language = 'ja'
            } else {
                this.language = 'en'
            }
            if (this.language === 'zh-cn') {
                this.language = 'zh-CN'
            }
            if (this.language === 'zh-tw') {
                this.language = 'zh-TW'
            }
            if (['en', 'ja', 'ko', 'zh-CN', 'zh-TW'].indexOf(this.language) < 0) {
                this.language = 'en'
            }
            this.abc = this.language

            this.srcUrl = this.srcList[this.language.substr(0, 2)]
        }
        ;(function (doc, win) {
            var docEl = doc.documentElement,
                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                recalc = function () {
                    var clientWidth = docEl.clientWidth
                    var clientHeight = docEl.clientHeight

                    if (!clientWidth) return
                    if (clientWidth < 1200) {
                        if (this.language === 'ja') {
                            docEl.style.fontSize = 14 * (clientWidth / 844) + 'px'
                        } else {
                            docEl.style.fontSize = 16 * (clientWidth / 844) + 'px'
                        }
                        if (clientWidth > 1023) {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = '16px'
                            } else {
                                docEl.style.fontSize = '18px'
                            }
                        }
                    } else {
                        if (this.language === 'ja') {
                            docEl.style.fontSize = '16px'
                        } else {
                            docEl.style.fontSize = '18px'
                        }
                    }
                }
            if (!doc.addEventListener) return
            win.addEventListener(resizeEvt, recalc, false)
            doc.addEventListener('DOMContentLoaded', recalc, false)
        })(document, window)

        // 禁止双指放大
        document.documentElement.addEventListener(
            'touchstart',
            function (event) {
                if (event.touches.length > 1) {
                    event.preventDefault()
                }
            },
            false
        )
        var lastTouchEnd = 0
        document.documentElement.addEventListener(
            'touchend',
            function (event) {
                var now = Date.now()
                if (now - lastTouchEnd <= 300) {
                    event.preventDefault()
                }
                lastTouchEnd = now
            },
            false
        )
        document.addEventListener('gesturestart', function (event) {
            event.preventDefault()
        })
    },
    methods: {
        // 保存滚动值，这是兼容的写法
        handleScroll() {
            if (this.lang2 === 'zh') {
                this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (document.body.clientHeight / 2 - this.scrollTop < 10) {
                    this.isBottom = true
                } else {
                    this.isBottom = false
                }
            } else {
                this.isBottom = false
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, true)

        this.textBottom = lang[23]['en']
    },

    destroyed() {
        // 离开该页面需要移除这个监听的事件，不然会报错
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style  lang="less">
html,
body {
    min-height: 100%;
    text-align: center;
    // max-width: 1024px !important;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
    pointer-events: none;
}

a {
    text-decoration: none;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
#app {
    .boxBoss {
        position: relative;
        margin: 0 auto;
        max-width: 1024px !important;
        overflow: hidden;
        .bottomWrap {
            z-index: 8;
            // max-width: 1024px !important;
            position: fixed;
            bottom: 0;
            left: 0;
            margin-top: -8rem;
            background: rgba(33, 25, 89, 0.5);
            width: 100%;
            padding: 1.75rem 0 1.5rem;
            color: white;
            .storeWrap {
                margin: 0 auto;
                max-width: 1024px !important;
                max-height: 80px !important;
                padding: 0 2.5rem;
                display: flex;
                justify-content: space-around;
                align-items: center;
                a {
                    width: 31%;
                }
                img {
                    width: 100%;
                }
            }
            .tipsWrap {
                // max-height: 120px !important;
                padding: 0 2rem;
                margin-top: 2rem;
                height: auto;
                display: flex;
                justify-content: center;
                .imgWrap {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                img {
                    width: 7.3125rem;
                    max-width: 118px;
                    height: auto;
                }
                .tips {
                    flex: 1;
                    display: inline-block;
                    text-align: left;
                    margin-left: 1.5rem;
                    font-size: 0.5rem;
                    font-weight: 600;
                    max-width: 477px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue